import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ["Padres con hijos de 2 a 12 años que se sienten derrotados por los 'picky eaters'.", 'Madres que trabajan y necesitan soluciones nutricionales de 15 minutos o menos.', 'Familias que ven cómo sus hijos se enferman cada vez que empieza el ciclo escolar.', 'Padres conscientes que saben que el marketing del súper les está mintiendo.'];
  const isNotFor = ["Personas que buscan pociones mágicas o gomitas de vitaminas para 'arreglarlo' todo.", 'Padres que no están dispuestos a cambiar lo que ponen en el carrito del supermercado.', 'Fanáticos de las dietas extremas que quieren quitarle el placer de comer a sus hijos.'];
  return <section className="py-14 bg-cream" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-204">
          {/* Para quién ES */}
          <FadeIn direction="right" data-id="element-205">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-leaf h-full" data-id="element-206">
              <h3 className="text-2xl font-bold text-ink mb-8 flex items-center" data-id="element-207">
                Este manual{' '}
                <span className="text-leaf ml-2" data-id="element-208">ES para ti si...</span>
              </h3>
              <ul className="space-y-6" data-id="element-209">
                {isFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-210">
                    <CheckCircle2Icon className="w-6 h-6 text-leaf mr-4 flex-shrink-0 mt-0.5" data-id="element-211" />
                    <span className="text-ink/80 leading-relaxed" data-id="element-212">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO ES */}
          <FadeIn direction="left" delay={0.2} data-id="element-213">
            <div className="bg-white/50 rounded-3xl p-8 md:p-10 border border-ink/5 h-full" data-id="element-214">
              <h3 className="text-2xl font-bold text-ink/60 mb-8 flex items-center" data-id="element-215">
                Este manual{' '}
                <span className="text-red-500/80 ml-2" data-id="element-216">
                  NO es para ti si...
                </span>
              </h3>
              <ul className="space-y-6" data-id="element-217">
                {isNotFor.map((text, i) => <li key={i} className="flex items-start opacity-70" data-id="element-218">
                    <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-219" />
                    <span className="text-ink/80 leading-relaxed" data-id="element-220">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}